import styled, { css } from 'vue3-styled-components';

export const ManagePageContainer = styled.div`
    padding: 0 24px;
    margin-left: 260px;
    min-height: 100vh;
    background: #f8fafc;
    border-radius: 10px;
`;

export const MainContentWrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 0;
`;

// 헤더 섹션
export const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
    background: white;
    padding: 24px 32px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const HeaderTitle = styled.div`
    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #1e293b;
        margin: 0 0 8px 0;
    }
    
    span {
        color: #64748b;
        font-size: 16px;
        font-weight: 400;
    }
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const ActionButton = styled.button`
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

export const PrimaryButton = styled(ActionButton)`
    background: #0f4c5c;
    color: white;
    
    &:hover {
        background: #0a3a47;
    }
`;

// 검색 섹션
export const SearchSection = styled.div`
    margin-bottom: 32px;
`;

export const SearchCard = styled.div`
    background: white;
    padding: 24px 32px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SearchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;
    
    &:last-child {
        margin-bottom: 0;
    }
`;

export const SearchGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    
    label {
        font-weight: 600;
        color: #374151;
        min-width: 80px;
    }
`;

export const SearchField = styled.div`
    select {
        padding: 10px 16px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        background: white;
        color: #374151;
        font-weight: 500;
        transition: all 0.2s ease;
        
        &:focus {
            outline: none;
            border-color: #0f4c5c;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
    }
`;

export const SearchInput = styled.input`
    padding: 12px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    font-size: 14px;
    transition: all 0.2s ease;
    flex: 1;
    max-width: 300px;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
    
    &::placeholder {
        color: #9ca3af;
    }
`;

export const SearchButton = styled.button`
    padding: 12px 16px;
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        transform: translateY(-1px);
    }
`;

export const SearchIcon = styled.span`
    font-size: 16px;
`;

// 필터 관련
export const FilterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    
    label {
        font-weight: 600;
        color: #374151;
        min-width: 80px;
    }
`;

export const FilterChips = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

const chipProps = css`
    ${props => props.active && css`
        background: #0f4c5c;
        color: white;
        border-color: #0f4c5c;
    `}
`;

export const FilterChip = styled.div`
    padding: 8px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 20px;
    background: white;
    color: #374151;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    ${chipProps}
    
    &:hover {
        border-color: #0f4c5c;
        color: #0f4c5c;
    }
`;

export const StatusFilter = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

const statusChipProps = css`
    ${props => props.active && css`
        opacity: 1;
        transform: scale(1.05);
    `}
    
    ${props => {
        switch (props.status) {
            case 'active':
                return css`
                    background: #dcfce7;
                    color: #166534;
                    border-color: #22c55e;
                `;
            case 'inactive':
                return css`
                    background: #fef3c7;
                    color: #92400e;
                    border-color: #f59e0b;
                `;
            case 'expired':
                return css`
                    background: #fee2e2;
                    color: #dc2626;
                    border-color: #ef4444;
                `;
            case 'pending':
                return css`
                    background: #e0f2fe;
                    color: #0369a1;
                    border-color: #0ea5e9;
                `;
            default:
                return css`
                    background: #f1f5f9;
                    color: #475569;
                    border-color: #cbd5e1;
                `;
        }
    }}
`;

export const StatusChip = styled.div`
    padding: 6px 12px;
    border: 2px solid;
    border-radius: 16px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.2s ease;
    opacity: 0.7;
    ${statusChipProps}
    
    &:hover {
        opacity: 1;
        transform: scale(1.05);
    }
`;

// 통계 섹션
export const StatsSection = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-bottom: 32px;
`;

export const StatsCard = styled.div`
    background: white;
    padding: 24px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: center;
    transition: all 0.2s ease;
    
    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    }
`;

export const StatsNumber = styled.div`
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 8px;
    
    ${props => {
        switch (props.type) {
            case 'total':
                return `color: #cc5803;`;
            case 'general':
                return `color: #0d6efd;`;
            case 'basic':
                return `color: #dc3545;`;
            case 'discount':
                return `color:rgb(21, 142, 163);`;
            case 'medical':
                return `color: #20c997;`;
            default:
                return `color: #cc5803;`;
        }
    }}
`;

export const StatsLabel = styled.div`
    font-size: 16px;
    color: #64748b;
    font-weight: 500;
`;

export const ViewModeToggle = styled.div`
    display: flex;
    background: #f1f5f9;
    border-radius: 8px;
    padding: 4px;
`;

const toggleProps = css`
    ${props => props.active && css`
        background: white;
        color: #0f4c5c;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    `}
`;

export const ToggleButton = styled.button`
    padding: 8px 16px;
    border: none;
    background: transparent;
    color: #64748b;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    ${toggleProps}
`;

// 테이블
export const TableContainer = styled.div`
    overflow-x: auto;
`;

export const ModernTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    
    th, td {
        padding: 16px;
        text-align: center;
        border-bottom: 1px solid #f1f5f9;
    }
    
    th {
        background: #f8fafc;
        font-weight: 600;
        color: #374151;
        font-size: 14px;
        white-space: nowrap;
    }
    
    td {
        color: #1e293b;
        font-size: 14px;
    }

    // 수급자성함 컬럼
    th:nth-child(1), td:nth-child(1) {
        width: 120px;
        min-width: 120px;
    }

    // 생년월일 컬럼
    th:nth-child(3), td:nth-child(3) {
        width: 100px;
        min-width: 100px;
    }
    
    // 대상 컬럼
    th:nth-child(4), td:nth-child(4) {
        width: 100px;
        min-width: 100px;
    }

    // 관계 컬럼
    th:nth-child(7), td:nth-child(7) {
        width: 60px;
        min-width: 60px;
    }
    
    tbody tr {
        transition: all 0.2s ease;
        
        &:hover {
            background: #f8fafc;
        }

        // 급여 row 색상
        &.benefit-row {
            background: rgba(15, 76, 92, 0.05);
            border-left: 4px solid #0f4c5c;
            
            &:hover {
                background: rgba(15, 76, 92, 0.12);
            }
        }

        // 비급여 row 색상
        &.non-benefit-row {
            background: rgba(251, 139, 36, 0.07);
            border-left: 4px solid #fb8b24;
            
            &:hover {
                background: rgba(251, 139, 36, 0.15);
            }
        }
    }
`;

export const TableSection = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: hidden;
`;

export const TableHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 24px 32px;
    border-bottom: 1px solid #e5e7eb;
`;

export const SubTitle = styled.h2`
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    margin-right: 15px;
`;

export const TableActions = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

// 수급자 정보
export const InfoText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const Name = styled.div`
    color: #1e293b;
    font-size: 14px;
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
`;

// 활성 필터 관련 스타일
export const ActiveFilterChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const ActiveFilterChip = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: #ff6b6b;
  color: white;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #ff5252;
    transform: translateY(-1px);
  }
`;

export const ClearAllFiltersButton = styled.button`
  padding: 6px 16px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #5a6268;
    transform: translateY(-1px);
  }
`;

export const BenefitTypeChip = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  
  ${props => {
        switch (props.type) {
            case '일반':
                return `
          background: rgba(13, 110, 253, 0.1);
          color: #0d6efd;
          border: 1px solid rgba(13, 110, 253, 0.3);
        `;
            case '기초':
                return `
          background: rgba(220, 53, 69, 0.1);
          color: #dc3545;
          border: 1px solid rgba(220, 53, 69, 0.3);
        `;
            case '산소':
                return `
        background: rgba(220, 53, 69, 0.1);
        color: #dc3545;
        border: 1px solid rgba(220, 53, 69, 0.3);
        `;
            case '의료급여':
                return `
          background: rgba(32, 201, 151, 0.1);
          color: #20c997;
          border: 1px solid rgba(32, 201, 151, 0.3);
        `;
            case '당뇨':
                return `
        background: rgba(32, 201, 151, 0.1);
        color: #20c997;
        border: 1px solid rgba(32, 201, 151, 0.3);
        `;
            case '감경':
                return `
          background: rgba(21, 142, 163, 0.1);
          color: rgb(21, 142, 163);
          border: 1px solid rgba(21, 142, 163, 0.3);
        `;
            case '보장구':
                return `
        background: rgba(21, 142, 163, 0.1);
        color: rgb(21, 142, 163);
        border: 1px solid rgba(21, 142, 163, 0.3);
        `;
            default:
                return `
          background: rgba(204, 88, 3, 0.1);
          color: #cc5803;
          border: 1px solid rgba(204, 88, 3, 0.3);
        `;
        }
    }}
`;

// 상태 배지
const statusBadgeProps = css`
    ${props => {
        switch (props.status) {
            case 'active':
                return css`
                    background: #dcfce7;
                    color: #166534;
                `;
            case 'inactive':
                return css`
                    background: #fef3c7;
                    color: #92400e;
                `;
            case 'expired':
                return css`
                    background: #fee2e2;
                    color: #dc2626;
                `;
            case 'pending':
                return css`
                    background: #e0f2fe;
                    color: #0369a1;
                `;
            default:
                return css`
                    background: #f1f5f9;
                    color: #475569;
                `;
        }
    }}
`;

export const StatusBadge = styled.span`
    padding: 6px 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
    ${statusBadgeProps}
`;

// 만료일
const expiryProps = css`
    ${props => props.expired && css`
        color: #dc2626;
        font-weight: 600;
    `}
`;

export const ExpiryDate = styled.div`
    color: #374151;
    ${expiryProps}
`;

// 페이지네이션
export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 32px;
    border-top: 1px solid #e5e7eb;
`;

export const Pagination = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PaginationButton = styled.button`
    padding: 4px 6px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #374151;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const paginationNumberProps = css`
    ${props => props.active && css`
        background: #fb8b24;
        color: white;
        border-color: #fb8b24;
    `}
`;

export const PaginationNumber = styled.button`
    min-width: 36px;
    height: 36px;
    padding: 0 8px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #374151;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    white-space: nowrap;
    ${paginationNumberProps}
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
    }
`;

export const ItemsPerPageSelector = styled.div`
    select {
        padding: 8px 12px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        background: white;
        color: #374151;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        margin-right: 15px;
        
        &:focus {
            outline: none;
            border-color: #0f4c5c;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
    }
`;

// 빈 상태 표시용 스타일
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
`;

export const EmptyStateIcon = styled.div`
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
`;

export const EmptyStateTitle = styled.h3`
  color: #6c757d;
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 600;
`;

export const EmptyStateText = styled.p`
  color: #adb5bd;
  margin: 4px 0;
  font-size: 14px;
`;